import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BoxV4, TextInputV4 } from '@labrav/react-components'
import { Typography } from '@mui/material'
import { useStyles } from './UsageDuration.styles'
import { FormikProps, useFormikContext } from 'formik'
import { PrivateOffer } from '../../../../modules/privateOffer/types'
import { get, isNil } from 'lodash'

export const UsageDuration = () => {
  const { classes } = useStyles()
  const formikProps = useFormikContext() as FormikProps<PrivateOffer>
  const { values, errors, touched, handleBlur, handleChange } = formikProps
  return (
    <>
      <div data-testid="usage-duration-section">
        <BoxV4
          heading={'Usage duration'}
          headingIcon={
            <FontAwesomeIcon
              icon={faListCheck}
              style={{ width: '18px', height: '14px' }}
            />
          }
        >
          <div className={classes.sectionContainer}>
            <Typography className={classes.sectionText}>
              After the contract duration ends, buyer can use metering price($)
              for the duration specified below. This offer switches back to
              public price($) after the specified number of days.
            </Typography>
            <Typography className={classes.sectionHeading}>
              Usage duration in days
            </Typography>
            <div className={classes.textFieldWidth}>
              <TextInputV4
                keyName="usageDuration"
                title={'Add number of days'}
                type="number"
                placeHolder=""
                value={
                  !isNil(values?.usageDuration) ? values?.usageDuration : ''
                }
                isError={
                  !!(
                    get(touched, 'usageDuration', false) &&
                    get(errors, 'usageDuration', false)
                  )
                }
                onChange={handleChange}
                isReadOnly={false}
                isRequired={false}
                errorText={
                  (!!get(touched, 'usageDuration', false) &&
                    get(errors, 'usageDuration', ' ')) ||
                  ' '
                }
                showSpinner={false}
                onBlur={handleBlur}
                keyToPrevent={['+', '-', '.', 'e']}
              />
            </div>
          </div>
        </BoxV4>
      </div>
    </>
  )
}
